import axios from 'axios';
import router from '@/router';
import {
  getCookie
} from '@/utils/util'
// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params, contentType = 'application/x-www-form-urlencoded') => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': contentType,
      Authorization: getCookie('dkh_token')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        if (contentType == 'application/x-www-form-urlencoded') {
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        } else {
          return data
        }
      }
    ]
  }).then(res => {
    //token过期
    if (res.data.code == 300) {
      router.push({
        path: '/login'
      })
      return;
    }
    return res.data
  });
};

export {
  loginreq,
  req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js